<template>
  <footer class="footer custom" :class="{ 'guest' : isGuest }">
    <div class="content is-size-7 has-text-grey">
      <p class="footer-label">
        <span>{{ new Date().getFullYear() }} | engineered by</span>
        <a href="https://www.seesaw.it" target="_blank" class="footer-icon">
          <img src="~/assets/images/seesaw_logo.png" />
        </a>
      </p>
    </div>
  </footer>
</template>
<script>
export default {
  name:"CustomFooter",
  props: {
    isGuest: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>
<style lang="scss">
.footer-label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-icon {
  height: 22px;
  margin-left: 2px;
  & > img {
    height: 100%;
  }
}
</style>